var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useContext, useState, createContext, useEffect } from '@max/max';
import { getPlatformType, isDianpingAppOrWebview, PlatformType } from '@nibfe/mkt-env-api';
import View from '@hfe/max-view';
import Horizontal from './components/horizontal/index.web';
import HorizontalText from './components/horizontalText/index';
import DropDowm from './components/dropDowm/index.web';
import PopUp from './components/popup/index.web';
import Sensor from '@max/mbc-sensor';
import './index.scss';
import { getActuralDefaultCity } from './apis/GetDefaultCity';
const nation = {
    title: '不限',
    value: '0'
};
export const globalContext = createContext({});
const MyComponent = (props) => {
    const { demonstrations, isTop, addNation, selectedName, 
    // 默认选中城市
    // defaultHomeSelectedCity,
    singleCityStyle, allCityStyle, zIndex, citySelect, 
    // 城市选中列表
    isDefaultCityHighPriority, 
    // 默认城市最优展示
    isPredictCity, isUseCrossCity } = props;
    console.log('isPredictCity>>', isPredictCity, isDefaultCityHighPriority);
    const ctx = useContext(global._EngineGlobalContext);
    const isDp = isDianpingAppOrWebview() || getPlatformType() === PlatformType.dpMinaWebview;
    const defaultCity = {
        title: '北京',
        value: isDp ? 2 : 1
    };
    const [cityInfo, setCityInfo] = useState([]);
    // const [checkedCity, setCheckedCity] = useState<cityData>(defaultCity);
    const [checkedCity, setCheckedCity] = useState({});
    const isDefaultActualCity = isDefaultCityHighPriority; // 如果以默认城市优先，则不需要获取推测城市
    const [isActuralCity, setIsActuralCity] = useState(isDefaultActualCity);
    useEffect(() => {
        const initCityInfo = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const cityMap = citySelect === null || citySelect === void 0 ? void 0 : citySelect.map;
            const ids = isDp ? cityMap === null || cityMap === void 0 ? void 0 : cityMap.dpCityList : cityMap === null || cityMap === void 0 ? void 0 : cityMap.mtCityList;
            const names = cityMap === null || cityMap === void 0 ? void 0 : cityMap.nameList;
            if (!ids || ids.length !== (names === null || names === void 0 ? void 0 : names.length))
                return;
            const combinedArray = names === null || names === void 0 ? void 0 : names.map((name, index) => ({
                title: name,
                value: ids[index]
            }));
            let index = names === null || names === void 0 ? void 0 : names.indexOf(selectedName); // 如果能找到指定默认城市，则采用指定城市，否则采用第一个城市
            index = index < 0 ? 0 : index;
            const defaultCityId = ids[index];
            const defaultCityName = names[index];
            const cityItem = {
                title: defaultCityName,
                value: defaultCityId
            };
            if (!isDefaultCityHighPriority) {
                // 如果非强制展示默认城市，则根据规则获取
                try {
                    const { userId, token } = ctx._runtimeInfo.commonParams;
                    const acturalCityInfo = yield getActuralDefaultCity({
                        ctx,
                        isPredictCity,
                        userInfo: {
                            userId: Number(userId),
                            token: token
                        }
                    });
                    const { cityId, type } = acturalCityInfo;
                    if (cityId && type !== 'default') {
                        // 选择了城市，且不是兜底城市
                        const cityIndex = ids === null || ids === void 0 ? void 0 : ids.indexOf(Number(cityId)); // 判断城市是否在列表中，不在则用默认城市
                        if (cityIndex > -1) {
                            const cityName = names === null || names === void 0 ? void 0 : names[cityIndex];
                            cityItem.title = cityName;
                            cityItem.value = cityId;
                        }
                    }
                }
                catch (error) {
                    (_a = ctx === null || ctx === void 0 ? void 0 : ctx._raptorReport) === null || _a === void 0 ? void 0 : _a.reportLog('获取城市信息出错', error, {
                        category: 'jsError',
                        level: 'info'
                    });
                    console.error(error);
                }
            }
            setCheckedCity(cityItem);
            setIsActuralCity(true);
            if (addNation) {
                combinedArray.push(nation);
            }
            setCityInfo(combinedArray);
        });
        if (!isUseCrossCity) {
            initCityInfo();
        }
    }, [citySelect, selectedName, isDefaultCityHighPriority, addNation, ctx]);
    const onChecked = (city, index) => {
        var _a;
        (_a = ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mcReport('b_daodian_lowcode_s1i934ut_mc', {
            valLab: {
                item_name: city === null || city === void 0 ? void 0 : city.title,
                item_index: city === null || city === void 0 ? void 0 : city.value
            }
        });
        setCheckedCity(city);
    };
    const onCityChange = (city) => {
        if (isUseCrossCity) {
            const cityMap = citySelect === null || citySelect === void 0 ? void 0 : citySelect.map;
            const ids = isDp ? cityMap === null || cityMap === void 0 ? void 0 : cityMap.dpCityList : cityMap === null || cityMap === void 0 ? void 0 : cityMap.mtCityList;
            const names = cityMap === null || cityMap === void 0 ? void 0 : cityMap.nameList;
            if (!ids || ids.length !== (names === null || names === void 0 ? void 0 : names.length))
                return;
            const combinedArray = names === null || names === void 0 ? void 0 : names.map((name, index) => ({
                title: name,
                value: ids[index]
            }));
            let index = names === null || names === void 0 ? void 0 : names.indexOf(selectedName); // 如果能找到指定默认城市，则采用指定城市，否则采用第一个城市
            index = index < 0 ? 0 : index;
            const defaultCityId = ids[index];
            const defaultCityName = names[index];
            const cityItem = {
                title: defaultCityName,
                value: defaultCityId
            };
            if (city === null || city === void 0 ? void 0 : city.value) {
                const cityIndex = ids === null || ids === void 0 ? void 0 : ids.indexOf(Number(city.value)); // 判断城市是否在列表中，不在则用默认城市
                if (cityIndex > -1) {
                    const cityName = names === null || names === void 0 ? void 0 : names[cityIndex];
                    cityItem.title = cityName;
                    cityItem.value = city.value;
                }
            }
            setIsActuralCity(true);
            setCheckedCity(cityItem);
            if (addNation) {
                combinedArray.push(nation);
            }
            setCityInfo(combinedArray);
        }
    };
    useEffect(() => {
        var _a;
        if (isActuralCity && (checkedCity === null || checkedCity === void 0 ? void 0 : checkedCity.value)) {
            console.log('emit cityChanged >>', checkedCity.value);
            (_a = props === null || props === void 0 ? void 0 : props._communication) === null || _a === void 0 ? void 0 : _a.emit('cityChanged', checkedCity);
        }
    }, [checkedCity, isActuralCity]);
    useEffect(() => {
        console.log('checkedCity>>', checkedCity);
    }, [checkedCity]);
    useEffect(() => {
        var _a;
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('crossFreeCityChanged', onCityChange);
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('crossFreeCityChanged', onCityChange);
        };
    }, [props]);
    return <globalContext.Provider value={{
        // @ts-expect-error no types
        _LXReport: ctx._LXReport
    }}>
      <Sensor once={true} onAppear={() => {
        var _a;
        // 待后续添加埋点
        (_a = ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mvReport('b_daodian_lowcode_s1i934ut_mv');
    }}>
        <View>
          <Horizontal x-if={demonstrations === "horizontal"} citydata={cityInfo} checkedCity={checkedCity} isTop={isTop} allCityStyle={allCityStyle} zIndex={zIndex} cityInfo={citySelect === null || citySelect === void 0 ? void 0 : citySelect.map} 
    // @ts-expect-error no types
    _LXReport={props === null || props === void 0 ? void 0 : props._LXReport} _communication={props === null || props === void 0 ? void 0 : props._communication}/>
          <HorizontalText x-if={demonstrations === "horizontalText"} citydata={cityInfo} checkedCity={checkedCity} isTop={isTop} allCityStyle={allCityStyle} zIndex={zIndex} cityInfo={citySelect === null || citySelect === void 0 ? void 0 : citySelect.map} 
    // @ts-expect-error no types
    _LXReport={props === null || props === void 0 ? void 0 : props._LXReport} _communication={props === null || props === void 0 ? void 0 : props._communication}/>

          <DropDowm x-if={demonstrations === "dropDown"} citydata={cityInfo} onChecked={onChecked} checkedCity={checkedCity} isTop={isTop} singleCityStyle={singleCityStyle} zIndex={zIndex}/>
          <PopUp x-if={demonstrations === "popup"} cityInfo={citySelect === null || citySelect === void 0 ? void 0 : citySelect.map} singleCityStyle={singleCityStyle} checkedCity={checkedCity} _LXReport={ctx === null || ctx === void 0 ? void 0 : ctx._LXReport} _pageAPI={ctx === null || ctx === void 0 ? void 0 : ctx._pageAPI} _communication={props === null || props === void 0 ? void 0 : props._communication}/>
        </View>
      </Sensor>
    </globalContext.Provider>;
};
export default memo(MyComponent);
